import { EResult } from "../../RequestStatusRedesign/types";
import { closeScenarioPopupUseCase } from "../../logic/closePopup.case";
import { submitSmsCodeUseCase } from "../../../SMSConfirmationPopup/logic/submit.case";
export var getMapStateToCheckSmsCodeMaxAttempts = function getMapStateToCheckSmsCodeMaxAttempts(_ref) {
  var getContent = _ref.getContent,
    submitPayment = _ref.submitPayment;
  return function (getState, setState) {
    var content = getContent();
    return {
      buttons: [{
        children: content.statusScreens.buttons.anotherPaymentButtonText,
        disabled: false,
        onClick: function onClick() {
          closeScenarioPopupUseCase(setState);
        }
      }, {
        children: content.statusScreens.buttons.resendSmsCode,
        disabled: false,
        onClick: function onClick() {
          submitSmsCodeUseCase({
            submitPayment: submitPayment
          })(getState, setState).catch(console.error);
        }
      }],
      title: content.statusScreens.smsCodeMaxCheckError.title,
      description: content.statusScreens.smsCodeMaxCheckError.description,
      result: EResult.Error
    };
  };
};